import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  add_project_title_button: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    textDecorationLine: 'underline',
    gap: 4,
  },
  add_project_title_text: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 18,
    letterSpacing: 0.1,
    color: neutrals.neutralGrays.graphite,
  },
  add_project_title_input_text: {
    textAlign: 'right',
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  add_project_title_input: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  button_save_text: {
    color: brand.main.water,
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.32,
    fontWeight: 700,
  },
  details_container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  element_container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  group_buttons: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  divider: {
    width: 1,
    backgroundColor: '#CBCBCD',
    height: 29,
  },
  outline_button: {
    paddingHorizontal: 6,
    paddingVertical: 3,
    borderWidth: 2,
    borderColor: 'transparent',
  },
  outline_button_text: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 18,
    letterSpacing: 0.16,
  },

  button: {
    height: 40,
  },
  buttonInner: {
    paddingVertical: 8,
  },
  button_text: {
    color: neutrals.white,
    fontSize: 16,
    lineHeight: 22,
    fontWeight: 700,
    textAlign: 'center',
  },
  price_container: {
    flexDirection: 'row',
    gap: 11,
    width: 'auto',
  },
  product_count: {
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 0.32,
    lineHeight: 18,
    color: neutrals.neutralGrays.tarmac,
    paddingRight: 4,
  },
  formatted_estimate: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
  },
  formatted_original: {
    textDecorationLine: 'line-through',
    color: neutrals.neutralGrays.graphite,
    fontSize: 12,
    lineHeight: 24,
    letterSpacing: 0.1,
  },
  button_disabled: {
    backgroundColor: neutrals.neutralGrays.dust,
  },
  iconAddFrame: {
    width: 18,
    height: 18,
  },
  iconCart: {
    width: 18,
    height: 18,
  },
  leftAction: {
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 4,
    justifyContent: 'flex-start',
  },
  leftActionIcon: {
    width: 22,
    height: 22,
    padding: 2,
  },
  leftActionText: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
    color: brand.main.water,
  },
});
